import { useMutation } from '@apollo/client'
import { ItManagementUpdateEmployeeDocument } from 'generated/resources/graphql'

interface QueryParameters {
  id: number
  phoneNumber: string
}

export const useUpdateEmployee = () => {
  const [updateEmployee, { loading }] = useMutation(ItManagementUpdateEmployeeDocument)

  return {
    updateEmployee(params: QueryParameters) {
      return updateEmployee({ variables: { ...params } })
    },
    loading,
  }
}
